<div *zciLoading="isClientSegmentLoading$ | async">
    <router-outlet></router-outlet>
</div>
